import React from "react";

import styles from "../Team/team.module.scss";

import TeamCard from "./TeamCard";

import joerg from "../Team/Static/joerg.png";
import jan from "../Team/Static/jan.png";
import peter from "../Team/Static/peter.png";
import robby from "../Team/Static/robby.png";

const Team = () => {
  const cards = [
    // ? Jörg
    {
      id: "1",
      img: joerg,
      name: "Jörg Seeberger",
      duties: "Geschäftsführer & Leiter der Ausbildung",
      phoneNumber: "+49-172-944-0174",
      displayNumber: "+49 172 944 0174",
      email: "j.seeberger@fsheideteam.de",
    },

    // ? Robby

    {
      id: "2",
      img: robby,
      name: "Robby Mittag",
      duties: "Prokurist der Fahrschul GmbH & Ausbilder auf Nutzfahrzeugen",
      phoneNumber: " +49-152-3406-6464",
      displayNumber: " +49 152 3406 6464",
      email: "r.mittag@fsheideteam.de",
    },

    // ? Jan

    {
      id: "3",
      img: jan,
      name: "Jan Säuberlich",
      duties: "Ausbilder für PKW & Motorrad",
      phoneNumber: "+49-172-145-6549",
      displayNumber: "+49 172 145 6549",
      email: "j.saeuberlich@fsheideteam.de",
    },

    // ? Peter

    {
      id: "4",
      img: peter,
      name: "Peter Wildner",
      duties: "Ausbilder für PKW & Motorrad",
      phoneNumber: "+49-174-914-3710",
      displayNumber: "+49 174 914 3710",
    },
  ];

  return (
    <div className={styles["team-page-container"]}>
      <h2 className={styles["heading"]}>
        {" "}
        <span>Unser</span> Team
      </h2>
      <div className={styles["heading-underline"]}></div>

      <div className={styles["cards-container"]}>
        {cards.map((card) => (
          <TeamCard key={card.id} card={card} />
        ))}
      </div>
    </div>
  );
};

export default Team;
